import React from 'react';
import { ChartType } from '../../../entities';
import { Candlestick, Line } from '@benzinga/themed-icons';

import { ControlButton } from '../../shared/Button';

interface Props {
  changeType: (type: ChartType) => void;
  isActive: boolean;
  type: ChartType;
}

const Type = ({ changeType, isActive, type }: Props) => {
  const renderChartIcon = (chartType: ChartType) => {
    switch (chartType) {
      case ChartType.candlestick:
        return <Candlestick title="Candlestick Chart" />;
      case ChartType.line:
      default:
        return <Line title="Line Chart" />;
    }
  };

  const change = () => {
    changeType(type);
  };

  return (
    <ControlButton $isActive={isActive} onClick={change}>
      {renderChartIcon(type)}
    </ControlButton>
  );
};

export default Type;
